import React from 'react';
import {useTranslation} from 'react-i18next';
import {UncontrolledSpendView} from './UncontrolledSpendView';

/**
 * «Inversión sin control» SIN el Centro de Alertas (UD-5, 17/10): la solapa se abre a toda agencia con la
 * 2.1, y a la que no tiene el Centro se le muestra sola — el título y la vista, sin las otras solapas.
 *
 * Es un componente aparte a propósito: NO monta `AlertsCenterContent`, que pide la lista de reglas, el
 * correo de quien mira y el webhook (todos del Centro: sin él, 404). La vista ya trae su intro.
 */
export function UncontrolledSoloPage() {
    const {t} = useTranslation();
    return (
        <section className="section-content alc-screen" data-testid="alerts-uncontrolled-solo">
            <div className="alc-page">
                <header className="alc-head">
                    <div className="alc-head__text">
                        <h1 className="alc-head__title">{t('alerts_center.tabs.uncontrolled')}</h1>
                    </div>
                </header>
                <UncontrolledSpendView/>
            </div>
        </section>
    );
}

export default UncontrolledSoloPage;
